import { Columns } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { Skeleton } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { OAuthStepHeader } from "@unauthenticated/oauth/components/CanadaOAuthOnboardingFlow/OAuthStepHeader/OAuthStepHeader";
import { l } from "@unauthenticated/oauth/locales/i18n";

import * as styles from "./OAuthAuthorizationStep.styles";

const SkeletonOAuthAuthorizationStep = () => {
  const { t } = useTranslation();
  const { phoneLarge } = useBreakpoints();

  return (
    <div css={styles.main}>
      <OAuthStepHeader
        title={t(l.oauth.authorization.title)}
        description={t(l.oauth.authorization.description)}
      />
      {[0, 1].map(item => (
        <div key={item} css={styles.skeletonScope}>
          <Columns>
            <Columns.Column columnWidth={1}>
              <Skeleton type="image" imageSize="medium" isCircular />
            </Columns.Column>
            <Columns.Column>
              <Skeleton type="typography" typographySize="h1" margin="bottom" />
              <Skeleton type="typography" typographySize="h4" margin="bottomLarge" />
            </Columns.Column>
          </Columns>
        </div>
      ))}

      <div css={styles.actions}>
        <Skeleton type="button" isFullWidth={phoneLarge.lessThan} />
        <Skeleton type="button" isFullWidth={phoneLarge.lessThan} />
      </div>
    </div>
  );
};

export { SkeletonOAuthAuthorizationStep };
